module.exports = __webpack_public_path__ + "static/media/Grupo 3807.07d33bdf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/Grupo 3807.svg
// module id = 358
// module chunks = 0